module.exports = __webpack_public_path__ + "static/assets/bd26af6f0cffb22923bfdde359bb4300.jpg";